import {apiClient, getOne, createOne, updateOne, deleteOne, getAll} from "./Api";

const MODULE = 'city';

export function getCitiesByName(name) {
	return  apiClient.get(`${MODULE}?name=${name}`);
}

export function getCitiesById(ids) {
	return  apiClient.get(`${MODULE}?ids=${ids}`);
}
